import hasPermi from "./hasPermi";
import hasRole from "./hasRole";

const install = function(Vue) {
  Vue.directive("hasPermi", hasPermi);
  Vue.directive("hasRole", hasRole);
};

if (window.Vue) {
  window["hasRole"] = hasRole;
  window["hasPermi"] = hasPermi;
  Vue.use(install); // eslint-disable-line
}

export default install;



// WEBPACK FOOTER //
// ./src/directive/index.js